export default __webpack_public_path__ + "static/media/loader-logo.fabead1a.png";